import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ExtAuthConfigModel } from '@smarttask-common/src/lib/models/Integrations/Auth/ExtAuthConfigModel';

export enum ExtAuthConfigActionTypes {
    ADD_EXT_AUTH_CONFIG = '[ExtAuthConfig] Create ExtAuthConfig',
    ADD_EXT_AUTH_CONFIGS = '[ExtAuthConfig] Add ExtAuthConfigs',
    UPSERT_EXT_AUTH_CONFIG = '[ExtAuthConfig] Upsert ExtAuthConfig',
    UPSERT_EXT_AUTH_CONFIGS = '[ExtAuthConfig] Upsert ExtAuthConfigs',
    UPDATE_EXT_AUTH_CONFIG = '[ExtAuthConfig] Update ExtAuthConfig',
    UPDATE_EXT_AUTH_CONFIGS = '[ExtAuthConfig] Update ExtAuthConfigs',
    DELETE_EXT_AUTH_CONFIG = '[ExtAuthConfig] Delete ExtAuthConfig',
    DELETE_EXT_AUTH_CONFIGS = '[ExtAuthConfig] Delete ExtAuthConfigs',
    DELETE_ALL_EXT_AUTH_CONFIGS = '[ExtAuthConfig] Delete All ExtAuthConfigs',
    DELETE_ALL = '[ExtAuthConfig] Delete All',

    UPDATE_SELECTED_ID = '[ExtAuthConfig] Update SelectedId',
}

export class UpdateSelectedAuthId implements Action {
    readonly type = ExtAuthConfigActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_auth_id: string) {}
}

export class AddOne implements Action {
    readonly type = ExtAuthConfigActionTypes.ADD_EXT_AUTH_CONFIG;
    constructor(public config: ExtAuthConfigModel) {}
}

export class AddMany implements Action {
    readonly type = ExtAuthConfigActionTypes.ADD_EXT_AUTH_CONFIGS;
    constructor(public configs: Array<ExtAuthConfigModel>) {}
}

export class UpsertOne implements Action {
    readonly type = ExtAuthConfigActionTypes.UPSERT_EXT_AUTH_CONFIG;

    constructor(public config: ExtAuthConfigModel) {}
}

export class UpsertMany implements Action {
    readonly type = ExtAuthConfigActionTypes.UPSERT_EXT_AUTH_CONFIGS;
    constructor(public configs: Array<ExtAuthConfigModel>) {}
}

export class UpdateOne implements Action {
    readonly type = ExtAuthConfigActionTypes.UPDATE_EXT_AUTH_CONFIG;
    constructor(public config: Update<ExtAuthConfigModel>) {}
}

export class UpdateMany implements Action {
    readonly type = ExtAuthConfigActionTypes.UPDATE_EXT_AUTH_CONFIGS;
    constructor(public configs: Array<Update<ExtAuthConfigModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = ExtAuthConfigActionTypes.DELETE_EXT_AUTH_CONFIG;
    constructor(public auth_id: string) {}
}

export class DeleteMany implements Action {
    readonly type = ExtAuthConfigActionTypes.DELETE_EXT_AUTH_CONFIGS;
    constructor(public auth_ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = ExtAuthConfigActionTypes.DELETE_ALL_EXT_AUTH_CONFIGS;
    constructor(public auth_ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = ExtAuthConfigActionTypes.DELETE_ALL;
    constructor() {}
}

export type ExtAuthConfigActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedAuthId;
